export default __webpack_public_path__ + "static/media/colors_loading.0d80a986.gif";